export const Roles: string[] = [
  'Delegato',
  'Vicario',
  'Segretario',
  'Membro Segretario',
  'Segretario Emerito',
  'Iscritto',
  'Revisore Contabile',
  'Tesoriere',
  'Convenzione',
  'Tecnico Informatico',
];

export const Sectors: string[] = [
  'A. D. E.',
  'O. D. E.',
  'Impiegato',
  'O. O.',
  'Nessuno',
];

export const TypeContracts: string[] = [
  'Nessuno',
  'AT',
  'EX-COPIT',
]
